import { type OnChangeFn, type SortingState, getCoreRowModel } from "@tanstack/react-table"
import type { FC } from "react"

import { useSalesOrderPreviewColumns } from "../../hooks/useSalesOrderPreviewColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { SalesOrder } from "@/graphql/codegen/graphql"

interface SalesOrderPreviewTableProps {
  data: SalesOrder[]
  sorting: SortingState
  onSortingChange: OnChangeFn<SortingState>
}

export const SalesOrderPreviewTable: FC<SalesOrderPreviewTableProps> = ({ data, sorting, onSortingChange }) => {
  const columns = useSalesOrderPreviewColumns()

  return (
    <AerosBaseTable<SalesOrder>
      features={{
        tanstackOptions: {
          data,
          columns,
          state: { sorting },
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          getRowId: (row) => row.salesOrderId,
          onSortingChange,
        },
      }}
      noDataMessage='No sales orders found'
    />
  )
}
